var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconTokenUsdt = function SvgIconTokenUsdt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.718 7.778V5.823h4.447V2.74H3.821v3.084h4.46v1.955c-3.736.18-6.54.93-6.54 1.828 0 .899 2.8 1.644 6.54 1.828v6.452h3.437v-6.452c3.736-.178 6.541-.928 6.541-1.828s-2.802-1.648-6.54-1.828ZM10 10.85c-4.046 0-7.325-.625-7.325-1.378 0-.649 2.389-1.192 5.603-1.338v2.208a38.113 38.113 0 0 0 3.437 0V8.134c3.214.146 5.603.69 5.603 1.338.007.76-3.273 1.378-7.318 1.378Z"
  })));
};
export default SvgIconTokenUsdt;